import { KxyLineTheme } from "../.internal/themes/KxyLineTheme";
export default KxyLineTheme;